import React from 'react'
import { Button } from '@sainsburys-tech/fable'

const Footer: React.FC = () => {
  return (
    <div className="fable:text-center fable:sm:text-left fable:p-4">
      <Button variant="tertiary" className="ot-sdk-show-settings">
        Manage Cookies
      </Button>
    </div>
  )
}
export default Footer
